import React, { useRef, useState, useEffect } from 'react';
import styles from './style.module.scss';
import OrderStats from './orderStats';
import StatusTabs from './statusTab';
import FiltersComponent from './filtersComponent';
import OrderTable from './orderTable';
import { fetchOrders, fetchBrands, acceptOrders, postInvoice, readyToShip, reGenInvoice, updateSelfDeliveryStatus } from './indexApi';
import AlertComponent from '../../components/AlertComponent/index';

const OrderPage = () => {
    const [status, setStatus] = useState('NEW_ORDERS');
    const [searchedOrderId, setSearchedOrderId] = useState();
    const [selectedFilters, setSelectedFilters] = useState({ category: [], brand: [] });
    const [copySelectedFilters, setCopySelectedFilters] = useState({ category: [], brand: [] });
    const [showFilters, setShowFilters] = useState({ category: false, brand: false })
    const [orderData, setOrderData] = useState([]);
    const [stats, setStats] = useState({
        newOrders: 0,
        // active: 0,
        // inactive: 0,
        // pending: 0
    });
    const [reqObj, setReqObj] = useState({
        // sellerId: loginData.seller_id,
        page: 1,
        size: 15,
        status: 'NEW_ORDERS'
    })
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({
        msg: null,
        color: null
    })
    const errorColor = '#f44336';
    const successColor = '#4caf50';
    const [brandData, setBrandData] = useState([]);
    const [loader, setLoader] = useState(true);
    const [totalPageCount, setTotalPageCount] = useState(null);

    useEffect(() => {
        getOrders();
        getBrands();
    }, [reqObj]);

    //function to fetch orders
    const getOrders = async () => {
        setLoader(true);
        let obj = {
            status: reqObj.status,
            pageSize: reqObj.size,
            pageNo: reqObj.page
        }
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        let response = await fetchOrders(obj);
        if (response && response.data && response.data.status === "success") {
            setOrderData(response.data.data);
            setTotalPageCount(Math.ceil(response.data.count / reqObj.size));
            setStats({ ...stats, newOrders: response.data.newOrdersCount });
            setLoader(false);

        }
        else {
            setAlertFnc('Error while loading. Please try after sometime.', errorColor, true);
            setLoader(false);
        }
    }

    //function to fetch brand filters
    const getBrands = async () => {
        let rObj = {
            category: modifyFilters(reqObj.category)
        };
        let response = await fetchBrands(rObj);
        if (response && response.data && response.data.status === "success") {
            setBrandData(response.data.data);
        }
    }

    //function to modify category and brand obj
    const modifyFilters = (obj) => {
        let data;
        if (obj && obj.length > 0) {
            data = `(`;
            obj && obj.length > 0 && obj.map((item, index) => {
                if (index != obj.length - 1) {
                    data = data + `"${item}",`
                }
                else {
                    data = data + `"${item}")`
                }
            })
        }
        return data
    }

    //function to show alerts
    const setAlertFnc = (msg, type, show) => {
        setShowAlert(show);
        setAlertObj({ msg: msg, color: type })
    }

    //function to handle status tab changes
    const handleStatusChange = (value) => {
        let status = null;
        status = value;
        setStatus(value);
        setReqObj({ ...reqObj, status: value, page: 1 });
    }

    //function to accept orders
    const acceptOrder = async (item) => {
        let rObj = {
            orderId: item.orderId,
            shipmentId: item.shipmentId,
            isAccepted: true,
            remarks: "ACCEPTED BY SELLER"
        }
        await acceptOrders(rObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `Order is accepted successfully.`
                setAlertFnc(msg, successColor, true);
                getOrders();
            }
            else {
                let msg = res && res.data && res.data.msg ? res.data.msg : res.data.errors && res.data.errors[0]
                setAlertFnc(msg, errorColor, true);
            }
        })

    }

    //function to reject orders
    const rejectOrder = async (item, reason) => {
        let rObj = {
            orderId: item.orderId,
            shipmentId: item.shipmentId,
            isAccepted: false,
            remarks: reason
        }
        await acceptOrders(rObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `Order is rejected successfully.`
                setAlertFnc(msg, successColor, true);
                getOrders();
            }
            else {
                let msg = res && res.data && res.data.msg ? res.data.msg : res.data.errors && res.data.errors[0]
                setAlertFnc(msg, errorColor, true);
            }
        })
    }

    //function to search order Id
    const searchOrderId = (orderId) => {
        setReqObj({ ...reqObj, orderId: orderId, page: 1 });
        setSearchedOrderId('');
    }


    //function to handle filter selection
    const filterChange = (e, type) => {
        let arr = { ...selectedFilters };

        if (type === 'category') {
            if (e.target.checked) {
                arr.category.push(e.target.value);
            }
            else {
                let index = arr.category.findIndex(x => x === e.target.value);
                arr.category.splice(index, 1);
            }
        }
        else if (type === 'brand') {
            if (e.target.checked) {
                arr.brand.push(e.target.value);
            }
            else {
                let index = arr.brand.findIndex(x => x === e.target.value);
                arr.brand.splice(index, 1);
            }
        }
        setSelectedFilters(arr);
    }

    //function to cancel filters
    const cancelFilters = (type) => {
        let filters = { ...selectedFilters };
        let hideFilters = { ...showFilters };
        if (type === 'category') {
            filters.category = [...copySelectedFilters.category];
            hideFilters.category = false;
        }
        else if (type === 'brand') {
            filters.brand = [...copySelectedFilters.brand];
            hideFilters.brand = false;
        }
        setShowFilters(hideFilters)
        setSelectedFilters(filters);
    }

    //function to apply filters
    const applyFilter = async (type) => {
        let obj = { ...showFilters };
        let copy = JSON.parse(JSON.stringify(selectedFilters));
        let rObj = { ...reqObj };

        if (type === 'category') {
            obj.category = false;
            rObj.category = copy.category;
        }
        else if (type === 'brand') {
            obj.brand = false;
            rObj.brand = copy.brand;
        }
        rObj.page = 1;
        setReqObj(rObj)
        setShowFilters(obj);
        setCopySelectedFilters(copy);
    }

    //function to show filters
    const showFiltersFnc = (type) => {
        let obj = {
            category: false,
            brand: false
        };
        if (type === 'category') {
            obj.category = true;
        }
        else if (type === 'brand') {
            obj.brand = true;
        }
        setShowFilters(obj)
    }

    //function to handle items per page
    const setItemsPerPage = (value) => {
        let obj = { ...reqObj };
        obj.size = value;
        obj.page = 1;
        setReqObj(obj);
    }

    //function to handle pagination
    const handlePageChange = (type) => {
        let obj = { ...reqObj };
        if (type === 'Next') {
            obj.page++;
        }
        else {
            obj.page--;
        }
        setReqObj(obj);
    }

    //function to handle filters delete
    const handleDelete = (val, type) => {
        let filters = { ...selectedFilters };
        let copyFilters = { ...copySelectedFilters };
        let rObj = { ...reqObj };
        let index = filters[type].findIndex(x => x === val);
        filters[type].splice(index, 1);
        copyFilters[type].splice(index, 1);
        rObj[type] = filters[type];
        setReqObj(rObj);
        setSelectedFilters(filters);
    }

    //function to handle stats Tab
    const handleTab = (type) => {
        let rObj = { ...reqObj };

        if (type === 'newOrders') {
            rObj.page = 1;
            rObj.status = 'NEW_ORDERS';
        }
        setStatus(rObj.status);
        setReqObj(rObj);
    }

    //function to handle modelId search
    const handleSearchChange = (e, type) => {
        if (type === 'clear') {
            setSearchedOrderId(undefined);
        }
        else {
            setSearchedOrderId(e.target.value);
        }
    }

    //function to generate invoice
    const generateInvoice = async (item, serialNumber, deliveryType) => {
        let rObj = {
            orderId: item.orderId,
            shipmentId: item.shipmentId,
            serialNo: serialNumber,
            deliveryType: deliveryType
        }
        try {
            await postInvoice(rObj).then((res) => {
                if (res && res.data && res.status === 200) {
                    let msg = `Invoice generated successfully.`
                    setAlertFnc(msg, successColor, true);
                    getOrders();
                }
                else {
                    let msg = res && res.data && res.data.msg ? res.data.msg : res.data.errors && res.data.errors[0]
                    setAlertFnc(msg, errorColor, true);
                }
            })
        } catch (err) {
            let msg = err?.response?.data?.msg || err?.response?.data?.errors?.[0] || 'Failed to generate invoice. Please try again.'
            setAlertFnc(msg, errorColor, true);
        }
    }

    //function to regenerate invoice
    const reGenerateInvoice = async (item, serialNumber) => {
        let rObj = {
            orderId: item?.orderId,
            shipmentId: item?.shipmentId,
            serialNo: serialNumber
        }
        try {
            await reGenInvoice(rObj).then((res) => {
                if (res && res?.data && res?.data?.invoiceFilename) {
                    let msg = `Invoice regenerated successfully`
                    setAlertFnc(msg, successColor, true);
                    getOrders();
                }
                else {
                    let msg = res && res?.data && res?.data?.msg ? res?.data?.msg : res?.data?.errors && res?.data?.errors[0]
                    setAlertFnc(msg, errorColor, true);
                }
            })
        } catch (err) {
            let msg = err?.response?.data?.msg || err?.response?.data?.errors?.[0] || 'Failed to regenerate invoice. Please try again.'
            setAlertFnc(msg, errorColor, true);
        }
    }

    //function to update self delivery status (Out for Delivery / Delivered)
    const handleUpdateSelfDeliveryStatus = async (item, newStatus) => {
        let rObj = {
            orderId: item.orderId,
            shipmentId: item.shipmentId,
            status: newStatus,
            remarks: newStatus === 'OUT_FOR_DELIVERY' ? 'Out for delivery by seller' : 'Delivered by seller',
            createTracking: true,
            deliveryType: 'SELF'
        }
        await updateSelfDeliveryStatus(rObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let statusLabel = newStatus === 'OUT_FOR_DELIVERY' ? 'Out for Delivery' : 'Delivered';
                let msg = `Order ${item.orderId} marked as ${statusLabel} successfully.`
                setAlertFnc(msg, successColor, true);
                getOrders();
            }
            else {
                let msg = res && res.data && res.data.msg ? res.data.msg : 'Something went wrong.'
                setAlertFnc(msg, errorColor, true);
            }
        })
    }

    //function to handle ready to ship
    const readyToShipFnc = async (item) => {
        let rObj = {
            orderId: item.orderId,
            shipmentId: item.shipmentId
        }
        await readyToShip(rObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `Successfully marked order ${item.orderId} as ready to ship.`
                setAlertFnc(msg, successColor, true);
                getOrders();
            }
            else {
                let msg = res && res.data && res.data.msg ? res.data.msg : res.data.errors && res.data.errors[0]
                setAlertFnc(msg, errorColor, true);
            }
        })
    }

    return <div className={styles.mainContainer}>
        <h5>Order Management</h5>
        <AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
        <OrderStats stats={stats} handleTab={handleTab} />
        <StatusTabs status={status} handleStatusChange={handleStatusChange} />
        {/* <FiltersComponent
            searchedOrderId={searchedOrderId}
            handleSearchChange={handleSearchChange}
            searchOrderId={searchOrderId}
            filterChange={filterChange}
            applyFilter={applyFilter}
            selectedFilters={selectedFilters}
            cancelFilters={cancelFilters}
            showFilters={showFilters}
            showFiltersFnc={showFiltersFnc}
            brandData={brandData}
        /> */}
        <OrderTable
            status={status}
            acceptOrder={acceptOrder}
            rejectOrder={rejectOrder}
            handleDelete={handleDelete}
            copySelectedFilters={copySelectedFilters}
            orderData={orderData}
            pageLoader={loader}
            reqObj={reqObj}
            totalPageCount={totalPageCount}
            handlePageChange={handlePageChange}
            setItemsPerPage={setItemsPerPage}
            generateInvoice={generateInvoice}
            readyToShipFnc={readyToShipFnc}
            reGenerateInvoice={reGenerateInvoice}
            updateSelfDeliveryStatus={handleUpdateSelfDeliveryStatus}
        />
    </div>
}

export default OrderPage;